// Guided masterclass manual builder reusing the masterclass flow
import { ManualProgramBuilder } from '../../masterclass/manual/ManualProgramBuilder';

export const GuidedManualProgramBuilder = () => {
  return <ManualProgramBuilder model="masterclass&mentorship" />;
};

export default GuidedManualProgramBuilder;
